import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b123fd88&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b123fd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123fd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b123fd88')) {
      api.createRecord('b123fd88', component.options)
    } else {
      api.reload('b123fd88', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b123fd88&scoped=true&", function () {
      api.rerender('b123fd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25fBCgDQAMkcP/JS/comp/GuestBox.vue"
export default component.exports